import Login from '../views/Login.vue'
export default {
  path: '/',
  name: '',
  component: Login,
  iconCls: 'el-icon-user-solid',
  roles: ['AppUser'],
  hidden: true,
  children: [
    {
      path: '/login',
      component: () =>
                import('../views/system/login/index.vue'),
      name: '用户登录',
      hidden: true
    },
    {
      path: '/register',
      component: () =>
                import('../views/system/register/index.vue'),
      name: '用户注册',
      hidden: true
    },
    {
      path: '/apply',
      component: () =>
                import('../views/system/apply/index.vue'),
      name: '用户申请',
      hidden: true
    }
  ]
}
